import React, { useEffect, useState, useMemo } from "react";
import HeaderTable from "../../components/DataTable/HeaderTable";

import { Link } from "react-router-dom";
import "./style.css";
import ReactExport from "react-export-excel";
import Api from "../../services/api";

import { changeIndexToNepali, colorScale } from "../../utils";
import { Button } from "reactstrap";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];
export default function MapCustomTable({ comments, title, categories, index }) {
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [refresh, setRrefresh] = useState(false);
  const [yekcolumn, setyekcolumn] = useState([]);
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [downloadcontent, setDownloadContent] = useState();
  const [yekdata, seYekData] = useState();
  const ITEMS_PER_PAGE = 10;
  const fullMarks = [
    { id: "7", marks: 100 },
    { id: "6", marks: 100 },
    { id: "5", marks: 50 },
    { id: "4", marks: 100 },
    { id: "3", marks: 51 },
    { id: "2", marks: 75 },
    { id: "1", marks: 116 },
  ];
  const { name, total_score, ...rest } = categories;

  const downloadminstryreport = async () => {
    let data = await Api.downloadMinistryReport(
      localStorage.getItem("fiscalYear"),
      sessionStorage.getItem("provinceId")
    );
    seYekData(data);
    let a = data.response.data[0]["0"];
    let questionsArray = [];
    for (const key in a) {
      questionsArray.push({
        ministry_name: a[key].ministry_name,
      });
    }
    const filteredMinistries = questionsArray.filter(
      (obj) => obj.ministry_name !== undefined
    );
    setyekcolumn([{ ministry_name: "प्रश्नहरू" }, ...filteredMinistries]);
    let questionArray = [];
    // console.log(yekcolumn);
    for (let i = 0; i < data.response.data.length; i++) {
      for (const key in data.response.data[i]) {
        const questionName = data.response.data[i][key].question_name;
        const ministryScores = data.response.data[i][key];
        const row = {
          प्रश्नहरू: questionName,
        };
        for (const a in ministryScores) {
          row[ministryScores[a].ministry_name] = ministryScores[a].score;
        }
        questionArray.push(row);
      }
    }
    console.log(questionArray);
    setDownloadContent(questionArray);
  };
  const totalmarksfun = () => {
    let a = 0;
    for (const key in rest) {
      a += rest[key].total_marks;
    }
    return a;
  };
  useEffect(() => {
    // for (let i = 0; i < data.length; i++) {
    // }
    // downloadminstryreport();
  }, []);
  //   const displayFullMarks = (id) => {
  //     let marks = fullMarks.filter((item) => item.id === id);
  //     return changeIndexToNepali(marks[0].marks);
  //   };

  const headers = [
    { name: "क्र.स.", field: "id", sortable: false },
    { name: "मन्त्रालय", field: "name", sortable: false },

    {
      name: `पूर्णांङ्क (${changeIndexToNepali(totalmarksfun())})`,
      field: "score",
      sortable: false,
    },
  ];
  //   categories &&
  //     categories
  //       .map((item) => {
  //         const { name, total_score, ...rest } = item;
  //         return rest;
  //       })
  //       .map((item) =>
  //         headers.push({
  //           name: item.name + " (" + changeIndexToNepali(item.total_marks) + ")",
  //           field: item.name,
  //           sortable: false,
  //         })
  //       );
  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) => comment.name.toLowerCase().includes(search.toLowerCase())
        // ||
        // comment.img.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments && computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return (
      computedComments &&
      computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
      )
    );
  }, [comments, currentPage, search, sorting]);
  console.log(headers);
  for (const key in rest) {
    headers.push({
      name:
        rest[key].name +
        " (" +
        changeIndexToNepali(rest[key].total_marks) +
        ")",
      field: rest[key].name,
      sortable: false,
    });
  }

  // const downloadHandler = async () => {
  //   console.log(yekdata);
  //   if (yekdata) {
  //   }

  //   // setyekcolumn(data.response.data[0]["0"]);
  //   // setDownloadContent(data);
  // };
  return (
    <div className="card-layout">
      <div className="row">
        <div className="col col-12 text-center">
          {/* {console.log("commentsData", commentsData)} */}

          <div className="table-responsive table-1">
            <table className="table ">
              <HeaderTable
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                <tr>
                  <td>{changeIndexToNepali(index)}</td>

                  <td>
                    <Link
                      to={`/provincialEvaluation/${
                        province_data[sessionStorage.getItem("provinceId") - 1]
                      }`}
                    >
                      {categories.name}
                    </Link>
                  </td>
                  <td>{changeIndexToNepali(categories.total_score)}</td>
                  {Object.values(rest).map((item) => (
                    <td>{changeIndexToNepali(item.score)}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
